import React from "react";
import { Helmet } from "react-helmet";

const Assets = () => (
  <Helmet>
    <link rel="shortcut icon" href="/static/favicon.ico" />
  </Helmet>
);

export default Assets;
